import {CollectionFactory} from '@modifi/redux'
import {selectLanguage, selectLocale} from '@modifi/plugin-i18n'
import {pathOr, prop} from 'ramda'

import {serviceClientFactory} from '../../lib/ownClient'

const ACTION_KEY = 'countries/FETCH'

const {actions, selectors, reducer} = CollectionFactory({
  actionNamePrefix: ACTION_KEY,
  reducerPath: ['plugins', 'custom-countries'],
  fetchRequest: async state => {
    const client = serviceClientFactory(state)
    return client.Countries.all().then(res => res.data().countries)
  },
  entityPrimaryKeySelector: prop('alpha2'),
})

export default reducer

export const selectByAlpha2 = selectors.selectById
export const selectIsLoading = state => selectors.selectIsKeyWindowLoading(state, 'all')
export const selectAll = state => selectors.selectByKeyWindow(state, 'all')
export const selectCount = state => selectors.selectCountByKeyWindow(state, 'all')
export const selectNameByAlpha2 = (state, alpha2) => {
  let languageOrLocale = selectLanguage(state)
  const countryData = selectByAlpha2(state, alpha2.toUpperCase())

  if (languageOrLocale === 'zh') {
    languageOrLocale = selectLocale(state)
  }
  return countryData?.name?.[languageOrLocale.toLowerCase()] ?? countryData?.name?.en
}
export const selectEnglishNameByAlpha2 = (state, alpha2) =>
  pathOr('', ['name', 'en'], selectByAlpha2(state, alpha2.toUpperCase()))

export const aEnsureCountries = () => (dispatch, getState) => {
  // when we are loading already we do not re fetch
  if (selectIsLoading(getState())) {
    return
  }

  // when we fetch already -> do not fetch again
  if (selectCount(getState()) > 0) {
    return
  }

  actions.fetch('all')(dispatch, getState)
}

export const selectIsLoaded = state => !selectIsLoading(state) && selectCount(state) > 0
